import React from "react";
import api from "@/lib/api";
import { Mascot } from "@/components/Mascot";

export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) {
    api.post("/client-error", { message: String(err?.message || err).slice(0, 500), stack: String(info?.componentStack || "").slice(0, 1500), url: window.location.href }).catch(() => {});
  }
  componentDidUpdate(prev) { if (prev.resetKey !== this.props.resetKey && this.state.err) this.setState({ err: null }); }
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div data-testid="error-boundary" className="min-h-[60vh] flex items-center justify-center">
        <Mascot title="Diçka shkoi keq" text="Provo ta rifreskosh faqen.">
          <button data-testid="error-reload" onClick={() => window.location.reload()} className="mt-4 bg-emerald-500 text-white font-semibold rounded-full px-6 h-11">Rifresko</button>
          <p data-testid="error-detail" translate="no" className="mt-4 text-[10px] text-slate-400 break-all px-4">{String(this.state.err?.message || this.state.err).slice(0, 200)}</p>
        </Mascot>
      </div>
    );
  }
}
